import React from "react";

export default function Select({ label = "Type Of Company", options = [], onChange,value }) {

  return (
    <select
      className="h-[55px] rounded-full border-0 text-sm !px-5 mb-3 w-full border-none mx-1 outline-none bg-[#DFE8F0] placeholder-[#6C94B4] invalid:text-[#6C94B4] appearance-none bg-right-arrow"
      required
      onChange={(e) => onChange(e.target.value)}
      value={value}
    >
      <option value="" disabled selected>
        {label}
      </option>
      {options.map((item, index) => {
        return (
          <option value={item.value} className="text-[#6C94B4]" key={index} onClick={() => onChange(item.value)}>
            {item.label}
          </option>
        );
      })}
    </select>
  );
}
